import React, { useContext, useState } from 'react';
import { SignupHeader } from './SignupHeader';
import { AuthContext } from '../../contexts/AuthContext';
import SwipeableViews from 'react-swipeable-views';
import { useHistory } from 'react-router-dom';
import { createAccount } from '../../services/measureSvc';

import './SignupPage.scss';

const SignupPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState();
  const [gender, setGender] = useState();

  const [loading, setLoading] = useState('');
  const [pageTitle, setPageTitle] = useState('Email & Password');
  const [buttonLabel, setButtonLabel] = useState('Sign Up');
  const [currentIndex, setCurrentIndex] = useState(0);
  const { login } = useContext(AuthContext);
  const history = useHistory();

  const handleChange = (evt) => {
    if (evt && evt.target) {
      const { name, value } = evt.target;
      switch (name) {
        case 'email':
          setEmail(value);
          break;
        case 'password':
          setPassword(value);
          break;
        case 'firstName':
          setFirstName(value);
          break;
        case 'lastName':
          setLastName(value);
          break;
        case 'dateOfBirth':
          setDateOfBirth(value);
          break;
        case 'gender':
          setGender(value);
          break;
        default:
          break;
      }
    }
  };

  const setTitles = (nextIndex) => {
    if (nextIndex === 0) {
      setPageTitle('Email & Password');
      setButtonLabel('Sign Up');
    } else if (nextIndex === 1) {
      setPageTitle("What's your Name?");
      setButtonLabel('Continue');
    } else if (nextIndex === 2) {
      setPageTitle("What's your DOB?");
      setButtonLabel('Continue');
    } else if (nextIndex === 3) {
      setPageTitle("What's your gender?");
      setButtonLabel('Continue');
    } else if (nextIndex === 4) {
      setPageTitle('Review & Confirm');
      setButtonLabel('I Agree');
    }
  };

  const nextPage = async () => {
    if (currentIndex >= 4) {
      await submit();
    } else {
      let nextIndex = currentIndex + 1;
      setCurrentIndex(nextIndex);
      setTitles(nextIndex);
    }
  };

  const previousPage = () => {
    if (currentIndex <= 0) {
      history.goBack();
    } else {
      let nextIndex = currentIndex - 1;
      setCurrentIndex(nextIndex);
      setTitles(nextIndex);
    }
  };

  const checkValidation = () => {
    if (currentIndex === 0) {
      return !email || !password || !!loading;
    }
    if (currentIndex === 1) {
      return !firstName || !lastName || !!loading;
    }
    if (currentIndex === 2) {
      return !dateOfBirth || !!loading;
    }
    if (currentIndex === 3) {
      return !gender || !!loading;
    } else {
      return false;
    }
  };

  const submit = async () => {
    setLoading('logging in...');
    try {
      await createAccount({ email: email, name: `${firstName} ${lastName}`, is_superuser: false, password: password });
      await login(email, password);
      history.goBack();
      setLoading(null);
    } catch (err) {
      setLoading('login failed');
      setTimeout(() => setLoading(null), 1000);
    }
  };

  return (
    <div className="signup-panel">
      <SignupHeader pageTitle={pageTitle} onClick={previousPage}></SignupHeader>
      <SwipeableViews disabled={true} index={currentIndex}>
        <form className="signup-form" noValidate>
          <input placeholder="Email" type="email" name="email" value={email} onChange={(e) => handleChange(e)} />
          <input
            placeholder="Password"
            type="password"
            name="password"
            value={password}
            onChange={(e) => handleChange(e)}
          />
        </form>

        <form className="signup-form" noValidate>
          <input
            placeholder="First Name"
            type="text"
            name="firstName"
            value={firstName}
            onChange={(e) => handleChange(e)}
          />
          <input
            placeholder="Last Name"
            type="text"
            name="lastName"
            value={lastName}
            onChange={(e) => handleChange(e)}
          />
        </form>

        <form className="signup-form" noValidate>
          <input
            placeholder="Date of Birth"
            type="date"
            name="dateOfBirth"
            value={dateOfBirth}
            onChange={(e) => handleChange(e)}
          />
        </form>

        <div className="signup-form radio-toolbar" onChange={(e) => handleChange(e)}>
          <label>Male</label>
          <input type="radio" name="gender" value="Male"></input>

          <label>Female</label>
          <input type="radio" name="gender" value="Female"></input>

          <label>Other</label>
          <input type="radio" name="gender" value="Other"></input>
        </div>

        <div className="signup-form">
          <div className="review-item">
            <label>Name</label>
            <label>
              <span>{firstName}</span> <span>{lastName}</span>
            </label>
          </div>
          <div className="review-item">
            <label>Date of Birth</label>
            <label>{dateOfBirth}</label>
          </div>
          <div className="review-item">
            <label>Gender</label>
            <label>{gender}</label>
          </div>
          <p>
            Remember you own your avatar and data not us. You can delete any personal data at any time within the app.
          </p>
          <p>
            By continuing and submitting personal data to us, you agree to your data including your 3D avatar data being
            processed in line with our privacy policy.
          </p>
        </div>

        <div>
          <button type="submit" onClick={() => submit()} disabled={!email || !password || !!loading}>
            Signup
          </button>
        </div>
      </SwipeableViews>
      <button className="primary-button" type="submit" onClick={() => nextPage()} disabled={checkValidation()}>
        {' '}
        {buttonLabel}{' '}
      </button>
    </div>
  );
};

export default SignupPage;
